import React, { useEffect, useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import { Container, Row, Col } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { apiCommonTrigger } from '../../../Utils/apiServicehelper';
import { Config } from '../../../Utils/Config';
import { clearCache } from '../../../Utils/utils';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UserSignin = (props) => {
    const navigate = useNavigate();
    const { handleSubmit, control, watch, register } = useForm();
    const [userDetails, setUserDetails] = React.useState({});
    const [userNameErr, setUserNameErr] = React.useState('');
    const [pwdErr, setPwdErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    const [signIn, setSignIn] = React.useState(true);
    const [alertModal, setAlertModal] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [snackClr, setSnackClr] = React.useState('');
    const [snackMsg, setSnackMsg] = React.useState('');
    const [isLoading, setLoading] = useState(false);

    const onChangeValidation = (e) => {
        // User name validation
        if (e.target.name === 'username') {
            var name = e.target.value;
            if (name.length === 0) {
                setUserNameErr('User name required');
            } else {
                setUserNameErr('');
            }
        }

        // Confirm password validation
        if (e.target.name === 'password') {
            var name = e.target.value;
            if (name.length === 0) {
                setPwdErr('Password required');
            } else {
                setPwdErr('');
            }
        }

        // Email validation
        if (e.target.name === 'email') {
            var regName = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
            // var regName = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
            var name = e.target.value;
            if (name.length === 0) {
                setEmailErr('Email address required');
            } else {
                if (!regName.test(name)) {
                    setEmailErr('Email address is invalid');
                } else {
                    setEmailErr('');
                }
            }
        }
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
    }

    // Form submission
    const onHandleSubmit = (e, from) => { 
        e.preventDefault();
        if (from === 'signinForm') {
            if (!userNameErr && !pwdErr && userDetails.username && userDetails.password) {
                setLoading(true);
                apiCommonTrigger("post",`${Config.API_URL}/AuthToken/login`, {
                         "Email":userDetails.username,
                        "Password":userDetails.password
                        })
                    .then((res) => {
                        if (res.status === 200) {
                            setLoading(false);
                            localStorage.removeItem("impersonated");
                            localStorage.setItem('accessKey', res.data.token);
                            const userType = res.data.usertype;
                            localStorage.setItem('user', JSON.stringify(res.data));

                            if(userType == "Administrator"){
                                localStorage.setItem('isAdmin', true );
                                navigate("/admin/user-management")
                            }else{
                                navigate("/market-search");
                                localStorage.removeItem("isAdmin");
                            }
                        }
                        else if(res.status === 202){                                                    
                        clearCache();
                        navigate(`/2fa/${res.data?.sid}`);
                    }
                    else if(res.status === 203){
                        caches.open('session-cache').then((cache) => {
                          cache.put('api_flag', new Response('true'));
                        });                        
                        navigate(`/2fa/${res.data?.sid}`);
                    }

                        else{
                            setLoading(false);
                            handlingCatchError(res, navigate);
                          }
                    })
                    .catch(err => {
                        setLoading(false);
                        handlingCatchError(err, navigate);
                      })
                   
            }else{
                if(!userNameErr && !userDetails.username){
                    setUserNameErr('Please fill out this field');
                }
                if(!pwdErr && !userDetails.password){
                    setPwdErr('Please fill out this field');
                }
            }
        } else {
            if (!emailErr && userDetails.email) {
             
                setLoading(true);
                    apiCommonTrigger("post",`${Config.API_URL}/account/ResetPassword`, {
                        "Email":userDetails.email
                        })
               
                    .then((res) => {
                        if (res.status === 200) {
                            if(res.data === "success"){
                                setLoading(false);
                                setAlertModal(true);
                            }
                        }
                        else{
                            setLoading(false);
                            handlingCatchError(res, navigate);
                          }
                    })
                    .catch(err => {
                        setLoading(false);
                        handlingCatchError(err, navigate);
                      })
                  
            }else{
                if(!emailErr && !userDetails.email){
                    setEmailErr('Please fill out this field');
                }
            }
        }
    }

    // Alert modal for successful information
    const alertModalToggle = (value) => {
        setLoading(true);
        setAlertModal(value);
        setSignIn(true);
        resetForm();
    }

    //   Reset form
    const resetForm = () => {
        setUserDetails({});
        setEmailErr('');
        setUserNameErr('');
        setPwdErr('');
        setLoading(false);
    }

    // Form toggle
    const formToggle = (from) => {
        setLoading(true);
        if (from === 'signinForm') {
            setSignIn(false);
        } else {
            setSignIn(true);
        }
        resetForm();
    }

    const handleClick = () => {
        setOpen(true);
    };
    
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <div className='signin-page common-page'>
            {isLoading ? (
                <div className="loader-wrap">
                <div className="default-page loading loading-center"></div>
                </div>
            ) : (
                ""
            )}
            <Container>
                <div className='signin-form'>
                    <Row className='d-flex justify-content-center'>
                        <Col md={5} className="user-signin">
                            {signIn === true ?
                                <form onSubmit={(e) => onHandleSubmit(e, 'signinForm')} id='RVParkIQ_signin_form'>
                                    <h2>User Sign in</h2>
                                    <Row>
                                        <Col>
                                            <TextField
                                                label="Username"
                                                id="outlined-required"
                                                fullWidth
                                                value={userDetails.username ? userDetails.username : ''}
                                                name="username"
                                                onChange={(e) => onChangeValidation(e)}
                                                error={!!userNameErr}
                                                helperText={userNameErr ? userNameErr : null}
                                                margin="normal"
                                                required
                                                className='textbox-custom'
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <TextField
                                                label="Password"
                                                id="outlined-password-input"
                                                fullWidth
                                                value={userDetails.password ? userDetails.password : ''}
                                                name="password"
                                                onChange={(e) => onChangeValidation(e)}
                                                error={!!pwdErr}
                                                helperText={pwdErr ? pwdErr : null}
                                                type="password"
                                                margin="normal"
                                                required
                                                className='textbox-custom pwd-field'
                                            />
                                        </Col>
                                        <div className="pwd-link">
                                            <a href="javascript:void(0);" onClick={() => formToggle('signinForm')}>Forgot Password?</a>
                                        </div>
                                    </Row>
                                    <Row className='d-flex justify-content-center mt-2'>
                                        <Button onClick={() => resetForm()} className="reset-opt">Reset</Button>
                                        <Button onClick={(e)=> onHandleSubmit(e, 'signinForm')} type="submit" className='market-btn'>Submit</Button>
                                        
                                    </Row>
                                    <Row>
                                    <div className="line-hr">OR</div>
<div className='create-new-user'>
<h3>Create an account</h3>
Don't have an account? <a href="/market-data#pricing-details">Sign up here!</a>
</div>
                                    </Row>
                                </form> :
                                <form onSubmit={(e) => onHandleSubmit(e, 'forgotForm')} id='RVParkIQ_forgot_pwd_form'>
                                    <h2>Forgot Password</h2>
                                    <p>Provide your email address and we will send you a link to update your password.</p>
                                    <Row>
                                        <Col>
                                            <TextField
                                                label="Email Address"
                                                id="outlined-required"
                                                fullWidth
                                                value={userDetails.email ? userDetails.email : ''}
                                                name="email"
                                                onChange={(e) => onChangeValidation(e)}
                                                error={!!emailErr}
                                                helperText={emailErr ? emailErr : null}
                                                type="email"
                                                margin="normal"
                                                required
                                                className='textbox-custom'
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='d-flex justify-content-center mt-4'>
                                        <Button onClick={() => formToggle('forgotForm')} className="reset-opt">Cancel</Button>
                                        <Button onClick={(e)=> onHandleSubmit(e, 'forgotForm')} type="submit" className='market-btn'>Send</Button>
                                    </Row>
                                </form>}
                        </Col>
                    </Row>
                </div>
            </Container>
            <Dialog open={alertModal} className="modal-custom-popup forgot-pwd">
                <DialogTitle>Your request is successful!</DialogTitle>
                <DialogContent><p>If this email address has an active account, you will receive a password reset link in a few minutes. If you need further assistance please contact support.</p></DialogContent>
                <DialogActions>
                    <Button onClick={()=> alertModalToggle(false)} className="market-btn">OK</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={open} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity={snackClr} sx={{ width: '100%' }}>
                    {snackMsg}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default UserSignin;